import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

import { Colors } from '../../../../../design/color/Colors';

interface Props {
  groupName: string;
  passingPercent: number;
  count: number;
}

const useStyles = makeStyles(() => ({
  root: { marginBottom: '16px' },
  row: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' },
  name: { color: Colors.textSecondary },
  count: {
    background: Colors.bgSurface,
    borderRadius: '32px',
    alignSelf: 'self-start',
    padding: '0px 12px',
  },
}));

export const GroupCardComponentHeader = React.memo(({ groupName, passingPercent, count }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.row}>
        <Typography className={classes.name} variant="h5">{groupName}</Typography>
        <Typography className={classes.count} variant="subtitle1">{count}</Typography>
      </Box>
    </Box>
  );
});
